import LabTestManager from "./LabTestManager";

export default function TestsFromReceptionist() {
    return (
        <LabTestManager filter="FromReceptionist" />
    );
}
